// extracted by mini-css-extract-plugin
export var container = "_9t-0";
export var fallback = "_9t-5";
export var fallbackIcon = "_9t-6";
export var hidden = "_9t-2";
export var image = "_9t-3";
export var loaded = "_9t-4";
export var placeholder = "_9t-1";